import { Inject, Injectable } from '@angular/core';
import { APP_MESSAGES } from './message.provider';
import { AppMessages } from './message';

@Injectable({
  providedIn: 'root',
})
export class AppMessageService {
  messages: AppMessages = {} as AppMessages;

  constructor(@Inject(APP_MESSAGES) private _messages: AppMessages[]) {
    this.messages = _messages.reduce(
      (acc: AppMessages, current: AppMessages) => {
        return {
          ...current,
          ...acc,
        };
      },
      this.messages as AppMessages,
    );
  }

  resolve(message: string, params?: Record<string, string>): string {
    // TODO: Add support for i18n messages
    if (params) {
      message = Object.keys(params).reduce(
        (acc, param) => acc.replace(`:${param}`, params[param]),
        message,
      );
    }

    return message;
  }
}
